/*
 * Bridges the Usercentrics decision into Shopify's Customer Privacy API.
 *
 * The ucEvents listener is registered synchronously, before loadFeatures has
 * resolved. Usercentrics replays the stored decision for returning visitors
 * very early, and a listener installed inside the loadFeatures callback can
 * miss that replay: consent-tracking-api is a separate bundle, so its callback
 * runs a network round trip later. A missed event leaves Shopify on its
 * default consent state for the whole page view, and Shopify suppresses its
 * own cart tracking while consent is not granted — the add to cart still
 * works, it just never reaches Shopify's funnel. The decision is therefore
 * queued here and applied as soon as the API is available.
 */
(function () {
  var applyConsent = null;
  var pendingConsent = null;

  function consentFromEvent(detail) {
    switch (detail.action) {
      case "onDenyAllServices":
        return {
          analytics: false,
          marketing: false,
          preferences: false,
          sale_of_data: false
        };
      case "onAcceptAllServices":
      case "onNonEURegion":
        return {
          analytics: true,
          marketing: true,
          preferences: true,
          sale_of_data: true
        };
      default:
        /*
         * A partial selection carries no Usercentrics service for sale_of_data.
         * Omitting it leaves whatever Shopify stored from an earlier visit, so
         * it stayed at the previous value while the other three changed. It is
         * mirrored from the marketing decision instead, which is the same
         * pairing the accept-all and deny-all branches use.
         */
        return {
          analytics: detail["Shopify Analytics"],
          marketing: detail["Shopify Marketing"],
          preferences: detail["Shopify Preferences"],
          sale_of_data: detail["Shopify Marketing"]
        };
    }
  }

  /*
   * The event name must match the window event registered in the Usercentrics
   * admin under Implementation -> Data Layers & Events.
   */
  window.addEventListener("ucEvents", function (e) {
    if (!e.detail || e.detail.event !== "consent_status") return;
    var consent = consentFromEvent(e.detail);
    if (applyConsent) {
      applyConsent(consent);
    } else {
      pendingConsent = consent;
    }
  });

  window.Shopify.loadFeatures(
    [{ name: "consent-tracking-api", version: "0.1" }],
    function (error) {
      if (error) throw error;
      applyConsent = function (consent) {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
      };
      if (pendingConsent) {
        applyConsent(pendingConsent);
        pendingConsent = null;
      }
    }
  );
})();
